import { useEffect } from 'react'
import { useMapboxMapContext } from '../contexts/MapboxMapContext'
import { DeadEnd } from '@/shared/api/routes'

export interface UseDeadEndLayerProps {
  deadEnds: DeadEnd[]
  selectedDeadEnd?: DeadEnd
  onDeadEndClick?: (deadEnd: DeadEnd) => void
}

/**
 * Hook for managing dead end markers layer
 * NOTE: This hook is now deprecated - Dead end markers are handled by useCampsiteDiscoveryMarkers hook
 * This hook now only handles cleanup of old circle layers
 * TODO: Remove this hook entirely once migration is complete
 */
export function useDeadEndLayer({
  deadEnds,
  selectedDeadEnd,
  onDeadEndClick
}: UseDeadEndLayerProps) {
  const { map, isLoaded, styleLoaded } = useMapboxMapContext()

  useEffect(() => {
    if (!map.current || !isLoaded || !styleLoaded) return

    // Remove old circle layer if it exists
    if (map.current.getLayer('dead-end-markers')) {
      map.current.removeLayer('dead-end-markers')
    }
    if (map.current.getSource('dead-end-markers')) {
      map.current.removeSource('dead-end-markers')
    }
  }, [map, isLoaded, styleLoaded])
}

